export function getItemTransform(index: number) {
  const distanceFromSecond = index;

  if (distanceFromSecond === 1) {
    return {
      scale: 1.05,
      y: -25,
      opacity: 1,
      zIndex: 0,
    };
  }

  return {
    scale: 1 - distanceFromSecond * 0.05,
    y: -distanceFromSecond * 20,
    opacity: 1 - distanceFromSecond * 0.1,
    zIndex: index === 1 ? 10 : -30 - index,
  };
}
